/* eslint-disable */
export default function arrayBufferToBase64(buffer:ArrayBuffer):string {
  let binary = '';
  let bytes = new Uint8Array(buffer);
  let len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
  }

  return window.btoa(binary);
}
